import { Alert, Stack } from '@mui/material'

import { VehicleTypeFilter } from 'generated/graphql'

import { useSupplierActivationQueryInput } from './useSupplierActivationQueryInput'

export const SupplierActivationFootnote = () => {
  const { input } = useSupplierActivationQueryInput()
  const isFilteredByVehicle = input.vehicleType !== VehicleTypeFilter.All

  if (!isFilteredByVehicle) return null

  return (
    <Stack spacing={1} mt={2}>
      <Alert severity='info'>
        Drivers are classified by their registered fleet as it stands today, not as it stood when
        they were created. A supplier running both HGV and non-HGV vehicles appears under both
        filters, and one with no vehicle recorded appears only under All vehicle types, so the two
        filtered figures do not add up to the unfiltered one.
      </Alert>
    </Stack>
  )
}
